import PrintIcon from '@mui/icons-material/Print'
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import axios from 'axios'
import dayjs, { type Dayjs } from 'dayjs'
import printJS from 'print-js-updated'
import * as React from 'react'

export type PrintButtonProps = {
  deviceId: number
  fromDate: Dayjs
  toDate: Dayjs
  reportPath: 'reports/reportIndividual' | 'aquaDevices/reportIndividual'
  disabled?: boolean
  tooltipTitle?: string
  iconButtonSx?: SxProps<Theme>
  formatTypeId?: number
}

const PrintButton: React.FC<PrintButtonProps> = ({
  deviceId,
  fromDate,
  toDate,
  reportPath,
  disabled = false,
  tooltipTitle = 'Печать',
  iconButtonSx,
  formatTypeId = 2,
}) => {
  const [isLoading, setIsLoading] = React.useState(false)

  const handlePrint = React.useCallback(async () => {
    try {
      setIsLoading(true)
      const body = {
        deviceId,
        dateFrom: dayjs(fromDate).toISOString(),
        dateTo: dayjs(toDate).toISOString(),
        formatTypeId,
      }
      const res = await axios({
        url: `${import.meta.env.VITE_API_URL}/api/${reportPath}`,
        method: 'POST',
        data: body,
        withCredentials: true,
        responseType: 'blob',
        headers: {
          Accept: 'application/json',
        },
      })
      const reader = new FileReader()
      reader.readAsDataURL(res.data)
      reader.onloadend = function () {
        const base64data = reader.result
        const base64WithoutPrefix =
          base64data && typeof base64data === 'string'
            ? base64data.split(',')[1]
            : ''
        printJS({
          printable: base64WithoutPrefix,
          type: 'pdf',
          base64: true,
        })
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }, [deviceId, formatTypeId, fromDate, reportPath, toDate])

  return isLoading ? (
    <CircularProgress
      size={25}
      color='white'
    />
  ) : (
    <Box>
      <Tooltip
        title={tooltipTitle}
        placement='top'
      >
        <IconButton
          disabled={disabled}
          sx={iconButtonSx}
          onClick={handlePrint}
        >
          <PrintIcon
            htmlColor='#fff'
            fontSize='medium'
          />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export default PrintButton
